const actions = {
  isPlay: "isPlay",
  getProgress: "getProgress",
  seekChange: "seekChange",
  volumeChange: "volumeChange",
  nextSong: "nextSong",
  previousSong: "previousSong",
  onReady: "onReady",
  setInitialData: "setInitialData",
};

export default actions;
